import React from 'react';
import styled from '@emotion/styled';
import { Color, FontSize } from 'views/constants';
import { Header } from 'views/components/molecules/Header';
import { Driver } from 'views/components/atoms/Driver';
import { Footer } from 'views/components/molecules/Footer';

const Wrapper = styled.div`
  text-align: center;
  min-height: 100vh;
  background-color: ${Color.C5};
  font-size: ${FontSize.DEFAULT};
  color: ${Color.C1};
`;

type DefaultTemplateLayoutProps = {
  onClickHeader(): void;
  headerText?: string;
  footerLinks?: {
    text: string;
    href: string;
  }[];
  showLogo?: boolean;
  onBack?(): void;
  onComment?(): void;
};

export const DefaultTemplateLayout: React.FC<DefaultTemplateLayoutProps> = ({
  onClickHeader,
  headerText,
  footerLinks,
  showLogo,
  onBack,
  onComment,
  children,
}) => {
  return (
    <Wrapper>
      {headerText != null ? (
        <>
          <Header
            title={headerText}
            logo={showLogo}
            onBack={onBack}
            onComment={onComment}
            onClick={onClickHeader}
          />
          <Driver />
        </>
      ) : null}
      {children}
      {footerLinks ? <Footer links={footerLinks} /> : null}
    </Wrapper>
  );
};
